import Typography from '@mui/material/Typography';


export default function InfoWatchlistText() {
  
  return (
<div>
    
    <Typography variant="h6" >
    

Your DNA carries the instructions for how your body functions—and small changes in your DNA, called genetic variants, 
can affect your health in different ways. Some of these variants can increase your risk of developing certain conditions, 
while others may have little to no impact at all. 
This section explains how to interpret your results, disease categories and variant classifications in your report. 
Understanding these details will help you better navigate your results and what they mean for your health.
<br /><br />


Mendelian vs. Complex Disorders
<br /><br />
Mendelian Disorders: These are single-gene disorders, usually inherited in a simple pattern (dominant or recessive). 
If you have a pathogenic or likely pathogenic variant in a gene associated with a Mendelian disorder, 
it means there’s a higher chance that you may develop the associated disease, often with a clear family inheritance pattern.

<br /><br />
Common Complex Disorders: These disorders are influenced by a combination of genetic factors, lifestyle choices, and environmental factors. 
Variants in genes related to these conditions (like heart disease or diabetes) may increase your risk but don't guarantee that you'll develop the disease.
<br /><br />
How to Read Your Results
<br /><br />
Gene names appear in colored rectangles with rounded edges, alongside the its classification of the variant and variant type. 
By clicking on a variant, you’ll find more detailed information. 
This includes insights that will help your doctor or genetic counselor understand the variant’s potential effects, its role in disease, 
and what it may mean for your health.
<br /><br />
Variant classification
<br /><br />
These classifications come from ClinVar, a trusted database that collects information on genetic variants. Relevant variants are classified in the following categories:
<br /><br />
Pathogenic: These variants are known to cause disease or significantly increase the risk of developing a condition. (Color = ?)
<br /><br />
Likely Pathogenic: These variants have strong evidence that they might cause disease, but more research is needed to confirm this. (Color = ?)
<br /><br />
Risk Factor: These variants can raise your likelihood of developing certain conditions, although they don't guarantee that you will. (Color = ?)
<br /><br />
Likely Risk Allele: These variants have a high likelihood of increasing risk for a condition, but further evidence is needed. (Color = ?)
<br /><br />
Types of variant
<br /><br />
Genetic variants are differences in DNA sequences among individuals. These variations can affect how genes function and may influence traits or risk for diseases. The main types of genetic variants include:
<br /><br />
Single Nucleotide Variant (SNV) / Single Nucleotide Polymorphism (SNP)
Definition: A change in a single nucleotide (A, T, C, or G).
Example: A switch from A to G at a specific location.
SNPs refer to SNVs that are common (found in ≥1% of the population).
<br /><br />
Insertion/Deletion (Indel)
Definition: Addition or removal of a small number of nucleotides.
Example: Insertion of "AT" or deletion of "GTC".
Can cause frameshift mutations if they occur within coding regions.
<br /><br />
Structural Variants (SVs)
Larger changes in the genome structure, including:
Copy Number Variants (CNVs): Duplications or deletions of large DNA segments.
Inversions: A segment of DNA is reversed within the chromosome.
Translocations: Parts of one chromosome break and attach to another.
<br /><br />
Repeat Expansions
Definition: Abnormal increase in the number of repeat units (e.g., trinucleotide repeats).
Example: Huntington’s disease is caused by expansion of CAG repeats in the HTT gene.
<br /><br />
Mitochondrial Variants
Variants in the mitochondrial DNA (mtDNA), which can affect energy production and other cellular functions.
<br /><br />
Please note: While these variants provide insight into your genome, they don’t guarantee you’ll develop any conditions. 
Many factors, such as environment and lifestyle, also play a role in health outcomes.


</Typography>    
</div>

   )
}